(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-quantity"] && !Shopify.designMode) return;
  try {
    class QuantityInput extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.input = this.querySelector('input[type="number"]');
      if (!this.input) return;

      this.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity-step]');
        if (!button) return;
        this.step(button.dataset.quantityStep === 'up' ? 1 : -1);
      });
    }

    step(direction) {
      // stepUp/stepDown respect min, max and step, and clamp for us. They throw
      // on a non-numeric value, which is exactly when falling back to the
      // minimum is the right answer.
      try {
        if (direction > 0) this.input.stepUp();
        else this.input.stepDown();
      } catch (error) {
        this.input.value = this.input.min || 1;
      }

      this.input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('quantity-input')) {
    customElements.define('quantity-input', QuantityInput);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-yarn-calculator"] && !Shopify.designMode) return;
  try {
    // Kept in the block bundle so it is loaded only on product templates that use it.
  class YarnCalculator extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;

      this.projectSelect = this.querySelector('[data-yarn-project]');
      this.sizeSelect = this.querySelector('[data-yarn-size]');
      this.resultCount = this.querySelector('[data-yarn-result-count]');
      this.resultDetail = this.querySelector('[data-yarn-result-detail]');
      this.button = this.querySelector('[data-yarn-set-quantity]');
      this.limit = this.querySelector('[data-yarn-limit]');

      if (!this.projectSelect || !this.sizeSelect || !this.button) return;

      this.requirements = Array.from(this.sizeSelect.options).map((option) => ({
        project: option.dataset.project || '',
        value: option.value,
        label: option.textContent.trim(),
        metres: Number(option.dataset.metres)
      }));

      this.projectSelect.addEventListener('change', () => this.renderSizes());
      this.sizeSelect.addEventListener('change', () => this.update());
      this.button.addEventListener('click', () => this.setQuantity());

      // Variant changes replace only this direct child with fresh quantity-rule
      // data. Watching the direct child list avoids observing our own result text.
      this.ruleObserver = new MutationObserver(() => this.update());
      this.ruleObserver.observe(this, { childList: true });

      this.renderSizes();
    }

    disconnectedCallback() {
      if (this.ruleObserver) this.ruleObserver.disconnect();
    }

    renderSizes() {
      const choices = this.requirements.filter(
        (requirement) => requirement.project === this.projectSelect.value
      );

      const options = choices.map((requirement) => {
        const option = new Option(requirement.label, requirement.value);
        option.dataset.project = requirement.project;
        option.dataset.metres = String(requirement.metres);
        return option;
      });

      this.sizeSelect.replaceChildren(...options);
      this.sizeSelect.disabled = options.length === 0;
      this.update();
    }

    quantityRules() {
      const source = this.querySelector('[data-pdp-yarn-calculator-rules]');
      const min = Math.max(1, Number(source && source.dataset.min) || 1);
      const step = Math.max(1, Number(source && source.dataset.step) || 1);
      const parsedMax = Number(source && source.dataset.max);

      return { min, step, max: parsedMax > 0 ? parsedMax : null };
    }

    allowedQuantity(balls, rules) {
      const wanted = Math.max(balls, rules.min);
      return rules.min + Math.ceil((wanted - rules.min) / rules.step) * rules.step;
    }

    update() {
      const option = this.sizeSelect.options[this.sizeSelect.selectedIndex];
      const requiredMetres = Number(option && option.dataset.metres);
      const ballMetres = Number(this.dataset.ballMetres);
      const safety = Math.max(0, Number(this.dataset.safetyPercent) || 0);

      if (!(requiredMetres > 0) || !(ballMetres > 0)) {
        this.button.disabled = true;
        return;
      }

      const requiredWithSafety = requiredMetres * (1 + safety / 100);
      const balls = Math.ceil(requiredWithSafety / ballMetres);
      const rules = this.quantityRules();
      const quantity = this.allowedQuantity(balls, rules);
      const overLimit = rules.max !== null && quantity > rules.max;
      const displayQuantity = overLimit ? balls : quantity;
      const purchasedMetres = displayQuantity * ballMetres;

      const resultTemplate =
        displayQuantity === 1 ? this.dataset.textResultOne : this.dataset.textResultOther;
      this.resultCount.textContent = resultTemplate.replace('__count__', String(displayQuantity));

      const detailTemplate = safety > 0 ? this.dataset.textDetailSafety : this.dataset.textDetail;
      this.resultDetail.textContent = detailTemplate
        .replace('__metres__', String(purchasedMetres))
        .replace('__percent__', String(safety));

      this.button.textContent = this.dataset.textButton.replace('__count__', String(quantity));
      this.button.dataset.quantity = String(quantity);
      this.button.disabled = overLimit;

      this.limit.hidden = !overLimit;
      this.limit.textContent = overLimit
        ? this.dataset.textLimit.replace('__max__', String(rules.max))
        : '';
    }

    setQuantity() {
      if (this.button.disabled) return;

      const quantity = Number(this.button.dataset.quantity);
      if (!(quantity > 0)) return;

      const rules = this.quantityRules();
      let input = document.getElementById(this.dataset.quantityId);

      if (!input) {
        const form = document.getElementById(this.dataset.formId);
        if (!form) return;

        input = document.createElement('input');
        input.type = 'hidden';
        input.name = 'quantity';
        form.appendChild(input);
      } else {
        input.min = String(rules.min);
        input.step = String(rules.step);
        if (rules.max !== null) input.max = String(rules.max);
        else input.removeAttribute('max');
      }

      input.value = String(quantity);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  if (!customElements.get('yarn-calculator')) {
    customElements.define('yarn-calculator', YarnCalculator);
  }
  } catch(e) { console.error(e); }
})();

})();
